<div class="list-view-container">
    <div class="list-view-container__image">
        <ng-content select="[image]"/>
    </div>
    <div class="list-view-container__content">
        <ng-content />
    </div>
</div>
